import { ContentTypeFilterClause, MixedContentItemDefinition, SpaceDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { PublishedConnectionContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { PublishedConnectionCard } from '../../../app/spaces/CardView/PublishedConnectionCard';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { SpacesSiteUrls } from '../../../app/spaces/SpacesSiteUrls';
import { PublishedConnections } from '../../../publishedConnection/resources/PublishedConnections';
import { IContentInfo } from '../IContentInfo';
import { call } from 'redux-saga/effects';
import { getPublishedConnectionInfos } from '../../../app/sagas/spaces/SpacesSagaHelpers';

export const PublishedConnectionDefinition: MixedContentItemDefinition & SpaceDefinition<'publishedConnection'> = {
  itemType: 'publishedConnection',
  contentType: 'publishedConnection',
  singularName: Messages.publishedConnection,
  pluralName: Messages.publishedConnections,
  emptyStateMessage: Messages.publishedConnectionsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_PublishedConnections,
  contentFilterKeys: PublishedConnectionContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: PublishedConnectionCard,
  listViewIconUrl: imgPath('server_connection_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['publishedConnection']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.publishedConnectionUrl(contentId),
  getBasicQuery: () => {
    return PublishedConnections.all().withExtraParams(PublishedConnectionContentType.extraQueryParams);
  },
  fieldValueResourceType: 'publishedConnection',
  getContentInfo: (contentList: IContentInfo[]) => call(getPublishedConnectionInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: () => imgPath('spaces_masthead_published_connection.svg'),
};
